import { put, takeLatest, all } from 'redux-saga/effects'
import { asynch } from 'redux-asynch-middleware'

import { MatchInit } from '../../goose'
import { loginWithEmailPassword } from '../../../api'
import {
  LOGIN_REQUESTED,
  registerAsLoginProvider,
  login as authLogin
} from './auth'

const ns = (action) => `devAuth/${action}`
const LOGIN = asynch(ns('LOGIN'))

export const login = ({email,password}) => ({type:LOGIN, promise:loginWithEmailPassword({email,password})})

const reducer = x => x

function* onInit(){
  yield put(registerAsLoginProvider('dev'))
}

function* onLoginRequested(){
  const email = process.env.REACT_APP_USER_EMAIL;
  const password = process.env.REACT_APP_USER_PASSWORD;
  if (!email || !password){
    throw Error("You're in dev mode, using the dev-auth module, but you haven't set your USER_EMAIL and USER_PASSWORD in .env")
  }
  yield put(login({email, password}))
}

function* onSuccessfulLogin(action){
  const {user,api_token} = action.result
  yield put(authLogin({user:user, api_token:api_token}))
}

const saga = function*(){
  yield all([
    takeLatest(MatchInit('devAuth'),onInit),
    takeLatest(LOGIN_REQUESTED, onLoginRequested),
    takeLatest(LOGIN,onSuccessfulLogin)
  ])
}

export default {
  key: 'devAuth',
  reducer,
  saga,
  dependencies:[]
}



// WEBPACK FOOTER //
// ./src/redux/modules/auth/dev.js